import React from 'react';
import PropTypes from 'prop-types';
import { isFunction, defaults } from 'lodash';
import MenuItem from '../MenuItem';

export default class Menu extends React.Component {
  static propTypes = {
    tag: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    itemComponent: PropTypes.func,
    itemProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    itemClassName: PropTypes.string,
    onItemClick: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    tag: 'div',
    items: [],
    itemComponent: MenuItem,
    itemProps: {},
    itemClassName: undefined,
    onItemClick: undefined,
    className: undefined,
  };

  renderItem = (itemProps, index) => {
    const { itemComponent: Item, itemClassName, onItemClick } = this.props;
    let { itemProps: commonProps } = this.props;

    if (isFunction(commonProps)) {
      commonProps = commonProps(itemProps, index);
    }

    const props = defaults({}, itemProps, commonProps, {
      onClick: onItemClick,
      className: itemClassName,
    });

    return <Item key={index} {...props} />;
  };

  render() {
    const { tag: Tag, items, className } = this.props;

    return (
      <Tag className={className}>{items.map((item, index) => this.renderItem(item, index))}</Tag>
    );
  }
}
